<template>
  <div class="font-sora bg-[#0F0F0F] text-white relative">
    <section
      class="min-h-[800px] grid grid-cols-1 lg:grid-cols-2 pt-[100px] bg-cover bg-center relative justify-between items-center"
    >
      <div class="absolute inset-0 z-0">
        <div
          class="w-full h-full bg-[url('/assets/images/hero-background.webp')] bg-cover bg-center opacity-30"
        />
      </div>
      <div class="px-6 md:px-10 lg:pl-40 grid grid-flow-row gap-10 z-10">
        <div class="h-auto max-w-[800px]">
          <h1
            class="text-[36px] md:text-[48px] lg:text-[58px] font-semibold leading-snug text-white mb-5"
          >
            {{ t("hero.title") }} <br />
            <span
              class="text-gray-700 tracking-[10px] md:tracking-[20px] lg:tracking-[30px]"
              >{{ t("hero.subtitle") }}</span
            >
          </h1>
          <p
            class="text-base md:text-lg lg:text-[24px] leading-relaxed font-regular mb-10 whitespace-pre-line"
          >
            {{ t("hero.description") }}
          </p>
        </div>
        <div class="flex flex-col gap-4">
          <p class="text-base md:text-lg lg:text-[20px] mb-2">
            {{ t("hero.call") }}
          </p>
          <div class="flex flex-col md:flex-row gap-3">
            <NuxtLink
              to="/contact"
              class="text-black bg-white px-6 py-3 rounded-full text-lg text-center"
            >
              <p>
                {{ t("hero.start") }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="h-5 w-5 ml-2 text-[#3DCBB1] inline"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 
       7.293 6.707a1 1 0 011.414-1.414l4 4a1 
       1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </p>
            </NuxtLink>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import ChevronRight from "@/public/chevron-double-right.svg";
const { t } = useI18n();
</script>
